import axios from "axios";

import { BACKEND } from "./backend";

export const offersClient = axios.create({
  baseURL: `${BACKEND}/api`,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export const offersApi = {
  list: async (params = {}) => {
    const { data } = await offersClient.get("/offers", { params });
    return data;
  },
  create: async (channel) =>
    (await offersClient.post("/offers", { channel })).data,
  meta: async () => (await offersClient.get("/offers/meta")).data,
  assign: async (id, assigned_to) =>
    (await offersClient.post(`/offers/${id}/assign`, { assigned_to })).data,
  setStatus: async (id, workflow_status) =>
    (await offersClient.patch(`/offers/${id}/status`, { workflow_status })).data,
  approve: async (id, notes) =>
    (await offersClient.post(`/offers/${id}/approve`, { notes })).data,
  reject: async (id, reason) =>
    (await offersClient.post(`/offers/${id}/reject`, { reason })).data,
  updateCustomerParams: async (id, customer_params) =>
    (await offersClient.patch(`/offers/${id}/customer-params`, { customer_params })).data,
  updateShipping: async (id, shipping) =>
    (await offersClient.patch(`/offers/${id}/shipping`, { shipping })).data,
  markupOverride: async (id, applied) =>
    (await offersClient.patch(`/offers/${id}/markup-override`, { applied })).data,
  delete: async (id) => (await offersClient.delete(`/offers/${id}`)).data,
};

export const CHANNEL_META = {
  email_auto: { icon: "📧", label: "Email (automatica)" },
  email_manual: { icon: "📨", label: "Email (manuale)" },
  phone: { icon: "📞", label: "Telefono" },
  whatsapp: { icon: "💬", label: "WhatsApp" },
  manual: { icon: "✏️", label: "Manuale" },
};

export const STATUS_META = {
  info_da_richiedere: {
    label: "Info da richiedere",
    bg: "#E5E7EB",
    fg: "#374151",
  },
  in_lavorazione: { label: "In lavorazione", bg: "#DBEAFE", fg: "#1D4ED8" },
  in_attesa_approvazione: {
    label: "Attesa approvazione",
    bg: "#FED7AA",
    fg: "#C2410C",
  },
  approvata: { label: "Approvata", bg: "#DCFCE7", fg: "#16A34A" },
  inviata: { label: "Inviata", bg: "#D1FAE5", fg: "#047857" },
  vinta: { label: "Vinta", bg: "#FEF3C7", fg: "#A16207" },
  persa: { label: "Persa", bg: "#FEE2E2", fg: "#DC2626" },
};

export const JUDGMENT_META = {
  "ECCELLENTE": { bg: "#DCFCE7", fg: "#16A34A" },
  "BUONO": { bg: "#DBEAFE", fg: "#1D4ED8" },
  "ACCETTABILE": { bg: "#FEF3C7", fg: "#A16207" },
  "ACCETTABILE — al minimo": { bg: "#FEF3C7", fg: "#A16207" },
  "SOTTO SOGLIA": { bg: "#FEE2E2", fg: "#DC2626" },
  "RICHIESTA APPROVAZIONE": { bg: "#FED7AA", fg: "#C2410C" },
};
